import { storageService } from '@/utils/storage';
import type { Empresa } from '@/modelos/Auth';

const EVENT_NAME = 'senciyo:habilitacion-pse-changed';

export type EstadoHabilitacionPse = 'enProceso' | 'habilitada';

export interface RegistroHabilitacionPse {
  estado: EstadoHabilitacionPse;
  fecha: string;
}

function registroDeEmpresa(empresa: Empresa | undefined): RegistroHabilitacionPse | null {
  if (!empresa) return null;
  if (empresa.esHabilitacionPse && empresa.habilitacionPseConfirmadoAt) {
    return { estado: 'habilitada', fecha: empresa.habilitacionPseConfirmadoAt };
  }
  if (empresa.habilitacionPseEnviadoAt) {
    return { estado: 'enProceso', fecha: empresa.habilitacionPseEnviadoAt };
  }
  return null;
}

export function obtenerRegistroHabilitacionPseMock(ruc: string): RegistroHabilitacionPse | null {
  return registroDeEmpresa(storageService.getEmpresas().find((e) => e.ruc === ruc));
}

export function estaHabilitadaPseMock(ruc: string): boolean {
  return obtenerRegistroHabilitacionPseMock(ruc)?.estado === 'habilitada';
}

export function estaEnProcesoPseMock(ruc: string): boolean {
  return obtenerRegistroHabilitacionPseMock(ruc)?.estado === 'enProceso';
}

export function fechaHabilitacionPseMock(ruc: string): string | null {
  const registro = obtenerRegistroHabilitacionPseMock(ruc);
  return registro?.estado === 'habilitada' ? registro.fecha : null;
}

export function sincronizarHabilitacionPseLocal(empresaActualizada: Empresa): void {
  const empresas = storageService.getEmpresas();
  const actualizadas = empresas.map((empresa) => (
    empresa.id === empresaActualizada.id ? { ...empresa, ...empresaActualizada } : empresa
  ));
  storageService.updateEmpresas(actualizadas);
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function suscribirseAHabilitacionPseMock(callback: () => void): () => void {
  window.addEventListener(EVENT_NAME, callback);
  return () => window.removeEventListener(EVENT_NAME, callback);
}
